














































































































import { Vue, Component } from 'vue-property-decorator';
import { toI18n } from '@/utils/commonUtils';
import { PromotionInfo, YorN } from 'supporter';
import clonedeep from 'lodash.clonedeep';
import { GetProductsPromotionSetting, PatchProducts } from 'ncp-api-supporter/dist/types/modules/product/product';

@Component
export default class ModifyPromotion extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private promotionInfo = {
    partnerInfo: {
      partnerName: '',
      promotionAgreed: true,
    },
    ...this.batchPromotionInfo('Y')
  };
  private classType = 'DEFAULT';
  private promotionAgree(data) {
    let promotionAgreed = this.toI18n('DISAGREE');
    if (data.promotionAgreed) {
      promotionAgreed = this.toI18n('AGREE');
    }
    return promotionAgreed + ' (' + this.toI18n('PARTNER') + ' : ' + data.partnerName + ')';
  }

  private batchPromotionInfo(value: YorN) {
    return {
      promotionYn: value,
      additionalDiscountYn: value,
      couponYn: this.classType === 'RENTAL' ? 'N' : value,
      freeGiftYn: this.classType === 'RENTAL' ? 'N' : value,
    }
  }

  private get productNo() {
    return this.$route.params.mallProductNos;
  }

  private promotionYnChange() {
    const { promotionYn } = this.promotionInfo;
    this.promotionInfo = {
      ...this.promotionInfo,
      ...this.batchPromotionInfo(promotionYn),
    };
  }

  private save() {
    const params = {
      mallProductNos: this.productNo,
    };
    const request: { promotionInfo: PromotionInfo } = {
      promotionInfo: { ...this.batchPromotionInfo('N') },
    };

    Object.assign(request.promotionInfo, this.promotionInfo);
    this.$api.patchProducts({ params, data: request }).then(({ data }: any) => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      this.sendPostMessage(data);
      this.close();
    });
  }
  
  private sendPostMessage(data: PatchProducts) {
    const promotionData = { type: this.type, modifyPromotion: true, data: clonedeep(data) };
    
    window.opener.postMessage(promotionData);
  }

  private close() {
    window.close();
  }
  
  private get type() {
    return this.$route.query?.type;
  }
  
  private created() {
    document.body.classList.add('popup', 'popup_medium');
    this.$api
      .getProductsPromotionSetting({ params: { productNo: this.productNo } })
      .then(({ data: { promotionYn, additionalDiscountYn, couponYn, partnerInfo, ...rest } }: { data: GetProductsPromotionSetting }) => {
        // @NOTE 기등록 프로모션의 사은품 설정 마이그레이션 처리
        const freeGiftYn = rest?.freeGiftYn === 'Y' ? 'Y' : 'N';
        Object.assign(this.promotionInfo, { promotionYn, additionalDiscountYn, couponYn, freeGiftYn, partnerInfo });
      });

    this.$api
      .getProductsMallProductNo({
        pathParams: { mallProductNo: this.productNo },
      })
      .then(({ data: { classType } }) => {
        this.classType = classType.toString();
      });

    window.name = 'modifyPromotion';
  }
}
